import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||678}
    height={undefined}
    style={{borderRadius: 678/306}}
    viewBox="0 0 678 306"
    fill="none"
    {...props}
  >
    <path
      fill="#FF6E58"
      d="m540.828 296.671-66.005-66.005h.02l65.985 66.005Z"
    />
    <path
      fill="#222221"
      d="M539.835 304.276a27.26 27.26 0 0 1-1.816.169l.019.019 1.758-.168c1.27-.129 2.541-.258 3.812-.407l-3.783.397.01-.01Z"
    />
    <path
      fill="#FF6E58"
      d="M677.384 152.52c0 38.13-14.166 74.632-39.847 102.765-23.766 26.059-55.473 42.935-90.009 48.067l-3.326-3.325-3.345-3.346h-.02l-65.986-66.005h-.019l-3.723-3.743-3.763-3.742h57.548c38.954 0 70.641-31.697 70.641-70.661 0-18.862-7.356-36.591-20.688-49.933-13.362-13.362-31.092-20.708-49.953-20.708h-57.548l-70.641 70.641H280.936l3.742-3.743 1.549-1.538 47.292-47.313 2.641-2.64L433.436 0h91.408c84.103 0 152.54 68.418 152.54 152.52Z"
    />
    <path
      fill="#3F538D"
      d="m338.804 94.637-2.661 2.66-2.64 2.64-47.293 47.313-1.548 1.539-3.743 3.743-70.641-70.642-3.763-3.742L136.728 8.35l-3.365-3.365-3.326-3.325c2.561-.378 5.142-.695 7.723-.934.576-.06 1.182-.109 1.777-.148 4.269-.378 8.627-.566 12.985-.566h91.637l94.655 94.635-.01-.01Z"
    />
    <path
      fill="#222221"
      d="M547.529 303.352c-1.251.189-2.522.377-3.802.526l3.911-.407-.109-.109v-.01Zm-72.686-72.686h-.02l66.005 66.005-65.985-66.005Z"
    />
    <path
      fill="#3F538D"
      d="M547.527 303.354c-1.251.188-2.522.377-3.802.526l-.109.02-3.783.397a27.26 27.26 0 0 1-1.816.169c-4.249.407-8.667.595-13.174.595h-91.408L338.8 210.426l2.64-2.66 2.661-2.641 47.293-47.312 1.548-1.549 1.102-1.082 2.641-2.661 70.641 70.662 3.762 3.742 3.723 3.743 66.005 66.005h.02l3.345 3.345 3.326 3.326.02.01Z"
    />
    <path
      fill="#00E9BA"
      d="m396.697 152.515-2.641 2.66-1.102 1.082-1.549 1.549-47.292 47.312-2.661 2.641-2.64 2.66-94.655 94.635H152.52C68.417 305.044 0 236.627 0 152.515c0-40.731 15.864-79.05 44.682-107.878 23.14-23.13 53.21-38.23 85.343-42.994l3.326 3.325 3.365 3.365 69.787 69.788 3.763 3.742H152.47c-38.954 0-70.641 31.698-70.641 70.642 0 18.881 7.356 36.611 20.688 49.953 13.362 13.362 31.092 20.708 49.953 20.708h57.776l70.661-70.661h115.77l.02.01Z"
    />
  </svg>
)
export default SvgComponent
